import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  { label: "50. Yıl Mahallesi Koltuk Yıkama", path: "/sultangazi/50-yil-koltuk-yikama" },
  { label: "50. Yıl Mahallesi Battaniye Yıkama", path: "/sultangazi/50-yil-battaniye-yikama" },
  { label: "Cebeci Koltuk Yıkama", path: "/sultangazi/cebeci-koltuk-yikama" },
  { label: "Cebeci Yorgan Yıkama", path: "/sultangazi/cebeci-yorgan-yikama" },
  { label: "Habibler Koltuk Yıkama", path: "/sultangazi/habibler-koltuk-yikama" },
  { label: "Habibler Perde Yıkama", path: "/sultangazi/habibler-perde-yikama" },
  { label: "Sultançiftliği Koltuk Yıkama", path: "/sultangazi/sultanciftligi-koltuk-yikama" },
  { label: "Sultançiftliği Kuru Temizleme", path: "/sultangazi/sultanciftligi-kuru-temizleme" },
  { label: "Esentepe Koltuk Yıkama", path: "/sultangazi/esentepe-koltuk-yikama" },
  { label: "Esentepe Yerinde Yıkama", path: "/sultangazi/esentepe-yerinde-yikama" },
  { label: "Sultangazi Merkez Koltuk Yıkama", path: "/sultangazi/merkez-koltuk-yikama" }
];

const SultangaziServiceArea = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="text-[#003132] mt-0 w-full">
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          SULTANGAZİ HİZMET TÜRLERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full mt-2">
          {ServiceArea.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default SultangaziServiceArea;
